<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Cambiar Contraseña</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="alias"
                label="Alias"
                prepend-icon="person"
                type="text"
                required
              />
              <v-text-field
                v-model="email"
                autofocus
                autocomplete="username"
                label="Email"
                prepend-icon="mail"
                type="email"
                required
              />
              <v-text-field
                v-model="password"
                id="password"
                label="Contraseña actual"
                prepend-icon="lock"
                type="password"
                required
              />
              <v-text-field
                v-model="nueva_password"
                id="nueva_password"
                label="Nueva Contraseña"
                prepend-icon="lock"
                type="password"
                required
              />
            </v-form>
            <v-flex class="red--text" v-if="msj_informativo">{{msj_informativo}}</v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="cambiarClave()" color="primary">Cambiar contraseña</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      alias: "",
      email: "",
      password: "",
      nueva_password: "",
      msj_informativo: null
    };
  },
  methods: {
    cambiarClave() {
      this.msj_informativo = "";
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let parametros = {
        email: this.email,
        password: this.password,
        nueva_password: this.nueva_password
      };
      if (this.alias) {
        parametros.alias = this.alias;
      }
      axios
        .post("usuario/cambiarClave", parametros, configuracion)
        .then(respuesta => {
          console.log("cambiarClave");
          console.log("respuesta.data", respuesta.data);
          this.$store.dispatch("guardarToken", respuesta.data.tokenReturn);
          this.msj_informativo = "¡HECHO! Contraseña cambiada";
          this.alias = "";
          this.email = "";
          this.password = "";
          this.nueva_password = "";
        })
        .catch(error => {
          //console.log(eror);
          this.msj_informativo = null;
          if (error.response && error.response.data.message) {
            this.msj_informativo = error.response.data.message;
          } else {
            this.msj_informativo = "Ocurrió un error con el servidor.";
          }
        });
    }
  }
};
</script>

